import { termTestInstance } from '../axios';

const getOOSAvgs = (pagination: any, sortOrder: any, filterText: string, contractId: string) =>
  termTestInstance.post('/terms/oos-averages/list', { pagination, sortOrder, filterText, contractId });

export default {
  getOOSAvgs,
};